import React, { useState, useRef, useEffect } from 'react';
import DropdownUser from '../DropdownUser/DropdownUser';
import { useAuth } from 'contexts/AuthContext';

const AvatarDropdownWrapper = () => {
  const [isAvatarDropdownOpen, setIsAvatarDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const { user } = useAuth();

  // Fecha o dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsAvatarDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative avatar-dropdown-container" ref={dropdownRef}>
        <button
            onClick={() => setIsAvatarDropdownOpen(!isAvatarDropdownOpen)}
            className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
            aria-label="Menu do usuário"
            aria-expanded={isAvatarDropdownOpen}
        >
            {user?.avatar ? (
                <img
                    src={user.avatar}
                    alt={user.name}
                    className="w-10 h-10 rounded-full object-cover ring-2 ring-transparent hover:ring-terracota transition-all duration-200"
                />
            ) : (
                <div className="w-10 h-10 rounded-full bg-terracota flex items-center justify-center text-white font-semibold ring-2 ring-transparent hover:ring-terracota/50 transition-all duration-200">
                    {user?.name?.charAt(0).toUpperCase() || 'A'}
                </div>
                )}
                <div className="hidden md:block">
                    <p className="text-sm font-medium text-gray-900">{user?.name || 'Aluna'}</p>
                    <p className="text-xs text-gray-500">Aluna</p>
                </div>
                <svg
                    className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${
                      isAvatarDropdownOpen ? 'rotate-180' : ''
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m19 9-7 7-7-7" />
                </svg>
        </button>
    
        {isAvatarDropdownOpen && (
            <DropdownUser setIsAvatarDropdownOpen={setIsAvatarDropdownOpen} />
        )}
    </div>
  );
};

export default AvatarDropdownWrapper;
